/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateMunicipalCommand } from '../../models/update-municipal-command';
import { UpdateMunicipalCommandResult } from '../../models/update-municipal-command-result';

export interface ApiMunicipalUpdateMunicipalPatch$Params {
      body?: UpdateMunicipalCommand
}

export function apiMunicipalUpdateMunicipalPatch(http: HttpClient, rootUrl: string, params?: ApiMunicipalUpdateMunicipalPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateMunicipalCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiMunicipalUpdateMunicipalPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateMunicipalCommandResult>;
    })
  );
}

apiMunicipalUpdateMunicipalPatch.PATH = '/api/Municipal/UpdateMunicipal';
